import { cityURL } from '../common.urls';
import ImmutableModel from '../immutable.model';

/**
 * A City that has a collection of Locations.
 */
class City extends ImmutableModel {
  /**
   * @param {Number} id
   * @param {String} name Name of the City
   * @param {Array<Number>} locations Id list of locations related to this city
   * @param {Address} address
   * @param {Boolean} is_default Is this the default city for some selections
   * @param {Array<Number>} services List of online service IDs
   * @param {Array<Number>} other_services List of offline service IDs
   * @param {String} url Url of the city
   * @param {Number} distance Distance from the user's location to this city
   */
  constructor(
    id,
    name,
    locations,
    address,
    is_default,
    services,
    other_services,
    url,
    distance=null,
  ) {
    super();

    /**
     * {Boolean} is_default Is this the default selection in case no other is made.
     * is_default is based on default location is_default
     */
    this.id = id;
    this.is_default = is_default;
    this.name = name;
    this.card_title = this.name;
    this.locations = locations;
    this.address = address;
    this.services = services;
    this.other_services = other_services;
    this.url = url || cityURL(this);

    this.distance = distance;
    this.score = 0;
  }

  copy() {
    return new City(
      this.id,
      this.name,
      this.locations,
      this.address,
      this.is_default,
      this.services,
      this.other_services,
      this.url,
      this.distance
    );
  }
  getIds() {
    return this.locations;
  }

  isArea() {
    return true;
  }

  includes(ids) {
    return this.locations.some(id => ids.includes(id));
  }

  get domId() {
    return `city-${this.id}`;
  }
}

export default City;



// WEBPACK FOOTER //
// ./src/app/common/models/city.model.js